import { put } from "redux-saga/effects";
import { fingerPrintMatch } from "../../Services";

export function* FingerPrintMatch(action) {
  const payload = action.payload;
  try {
    const res = yield fingerPrintMatch(payload);

    yield put({ type: "REQ_MATCH_FINGERPRINT_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_MATCH_FINGERPRINT_FAILED", errData: e });
  }
}
